export default require('!!raw-loader!../__generated__/schema.all.graphql') as string;
